import { Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { Constants } from '../app.constants';
import { EchexpaymentService } from '../echexpayment.service';
import { UserService } from '../user.service';
import {  ElementRef, Renderer2  } from '@angular/core';

@Component({
  selector: 'echexpayment-checkout-url',
  templateUrl: './checkout-url.component.html',
  styleUrls: ['./generate-checkout-url.component.css']
})
export class CheckoutUrlComponent implements OnInit, OnDestroy {
	
	public secureUrlLink : any = {};
	busy:Subscription;
	public today_date : Date;
	public token:string;
	public key:string;
	public echeck_amount:string;
	public amountInWords:string;
	public bankname:string;
	public bankaddress:string;
	public bankcity:string;
	public bankzip:string;
    public id:string;
    public tokenj:string;
	public RedirectUrlLink : any = {};


	
	public validationName: boolean= false;
	public validationEmail: boolean= false;
	public invalidEmail : boolean= false;

	public validationAddess : boolean= false;
	public validationCity : boolean= false;
	public validationState : boolean= false;
	public validationZip : boolean= false;
  
	public validationCheck_number : boolean= false;
	public validationCheck_amount : boolean= false;
	public validationMemo : boolean= false;
	public validationRouting_number: boolean= false;
	public validationAccount_number : boolean= false;
	public validationConfirm_account_number : boolean= false;
	public match : boolean= false;
	public minAccountLength : boolean= false;

    public isCaptchaValid : boolean = false;
	public getPhoneNumber : any = {};
	public logo_image : any = {};
    public chequeerror_res:string;
    public checkRouting: string;
    public checkRoutingno: string;
	public showWarning: boolean = false;
	public characterLimitReached : boolean = false;
	NamecharacterLimitReached: { [key: string]: boolean } = {};

	@ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
	@ViewChild('submitButton') submitButton: ElementRef;
	@ViewChild('Focus_Captcha', { read: ElementRef }) focusCaptchaRef: ElementRef;
	
	constructor(private router: Router, private elementRef: ElementRef, private route: ActivatedRoute, private renderer: Renderer2, private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private userService:UserService, private CONSTANTS: Constants) { 

		this.router = router;
		this.today_date =  new Date(); 
        this.key = CONSTANTS.captcha_key;

	}

	ngOnDestroy() {
		this.toastr.clear();
	}

	ngOnInit() {
		this.getBankInfo();
	}
	
	ngAfterViewInit() {
		this.renderer.selectRootElement('#Focus_Name').focus();
	}
	
	  
	moveNext(nextInput: HTMLInputElement, number: number) {
		let captchaToken = this.captcha.getResponse();
		if(number === 3){
			if(captchaToken){
				if (this.submitButton && this.submitButton.nativeElement) {
					this.submitButton.nativeElement.focus();
					this.submitButton.nativeElement.click();
				}
			} else {
				setTimeout(() => {
					const iframeElement = this.focusCaptchaRef.nativeElement.querySelector('iframe');
					if (iframeElement) {
					iframeElement.focus();
					iframeElement.click();
					}
				}, 100);
		    }
		} else if(number === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
		} else{
		 nextInput && nextInput.focus();
		}
	 }


	validateInput(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          return;
        }
      
        if (!/^\d+$/.test(event.key)) {
          // Prevent input if it's not a digit
          event.preventDefault();
        }
      }

	// Amount to words
	// amountToWords(value){
	// 	this.amountInWords = this.echexpaymentService.toWords(value);
	// }
	amountToWords(value) {
		if (value < 999999999) {
			this.showWarning = false;
		} 
		if (value === null || value === undefined) {
		  this.amountInWords = '';
		} else {
		  const dollars = Math.floor(value);
		  const cents = Math.round((value - dollars) * 100);
		  let centsText = '';
	  
		  if (cents !== 0) {
			centsText = `${cents}/100`;
		  }
	  
		  this.amountInWords = `${this.echexpaymentService.toWords(dollars)}`;
	  
		  if (centsText) {
			this.amountInWords += ` and ${centsText} Cents`;
		  } else {
			this.amountInWords += ` and 00/100 Cents`;
		  }
	    }
	  }

	  DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
        
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) {
         // this.showWarning = false; // Hide the warning message
          event.preventDefault(); // Prevent invalid input
          return;
        }
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const maxValue = 999999999;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
          if (parseFloat(modifiedValue) > maxValue) {
            this.showWarning = true;
            setTimeout(() => {
              this.showWarning = false;
            }, 3000);
            event.preventDefault();
          }
          event.preventDefault();
        } 
      }

	// Get Bank Info

	getBankInfo(){
        
        let params: any = this.route.snapshot.params;
		var data = {
		  id :params._id,
		  token :params.token
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getBankInfoApi(data).subscribe(
			   response => {
				responseData = response;
                this.RedirectUrlLink = responseData.data.thank_you_url;
				this.secureUrlLink.transcation_fee =  responseData.data.transcation_fee;
				if(responseData.data.cheque_amount != ''){
				  const result =   parseFloat(responseData.data.cheque_amount ) + parseFloat(this.secureUrlLink.transcation_fee);
				  this.secureUrlLink.amount = result !== 0.00 ? result.toFixed(2) : '';

				  var amt = this.secureUrlLink.amount;
				  this.secureUrlLink.amount = amt;
                  this.echeck_amount = amt;
                  this.tokenj = responseData.data.user_token;
				  this.amountInWords = this.echexpaymentService.toWords(amt);
				}
				this.secureUrlLink.toname =  responseData.data.pay_to_the_order_of;
                this.getPhoneNumber = responseData.data.phone_number;
                this.logo_image = responseData.data.logo_image;
				this.secureUrlLink.memo  =  responseData.data.memo;
			 
			 },
			 error => {
                this.chequeerror_res = responseData.error.message;
				responseData = error;
				// this.toastr.error(responseData.error.message, 'Failed!');
			 }
		  );
	  }
	
	handleCorrectCaptcha(){
	 let captchaToken = this.captcha.getResponse();
	//  if(captchaToken){
	// 	 const saveButton = document.getElementById('submitButton') as HTMLElement;
	// 	 if (saveButton) {
	// 		 saveButton.focus();
	// 		 setTimeout(()=>{
	// 			saveButton.click();
	// 		 }, 1000)
	// 	 }
	//  }
     this.isCaptchaValid = false;
	}
	
	 //setAmountValue
    setAmountValue(amount){
		if(amount) {
			this.secureUrlLink.amount = parseFloat(amount).toFixed(2);
		}
    }
	
	
	eventHandler(){
        this.validationName = false;
        this.validationEmail = false;
        this.invalidEmail = false;

        this.validationAddess = false;
        this.validationCity = false;
        this.validationState = false;
        this.validationZip = false;
      
        this.validationCheck_number = false;
        this.validationCheck_amount = false;
        this.validationMemo = false;
        this.validationRouting_number= false;
        this.validationAccount_number = false;
        this.validationConfirm_account_number = false;
        this.match = false;
        this.minAccountLength = false;
    }
	// get routing info
	getRoutingInfo(routing_number){
        
        let params: any = this.route.snapshot.params;
		if(routing_number && routing_number.length >=9)
		{
		 let data = {
		  user_token:this.tokenj,
          token:params._id,
		  id:params._id,
		  routing_number:routing_number
		}
		let responseData = <any>{};
		this.userService.getRoutingInfoApi(data).subscribe(
		 response => {
			responseData = response;
			this.bankname = responseData.data.name;
			this.bankaddress = responseData.data.address;
			this.bankcity = responseData.data.city;
			this.bankzip = responseData.data.zip;
			if( responseData.status === 'error'){
				this.checkRouting = responseData.status;
				this.checkRoutingno = 'error';
			  } else{
				this.checkRouting = '';
				this.checkRoutingno = 'Success';
			}
		 }, 
		 error => {
			responseData = error;
            this.chequeerror_res = responseData.error.message;
			// this.toastr.error(responseData.error.message, 'Failed!');
		 }
		); 
		}
    }

	
	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	  }
	// Save cheque from checkout-url
	payChequeFromSecureLink(data){
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid && this.checkRoutingno === "Success"){ 
			if (data.value.amount > 999999999) {
				this.showWarning = true;
				return;
			} 
			if (data.value.checking_account_number !== data.value.confirm_account_number) {
				return;
			  }
            let model: any = data.value;
            // validate captcha
            let captcha_GetToken = this.captcha.getResponse();
            if (captcha_GetToken) {
                this.isCaptchaValid = false;
            } else{
                this.isCaptchaValid = true;
                return false;
            }

            let params: any = this.route.snapshot.params;
            model.token = params.token;
            model.captchaToken = this.captcha.getResponse();
            model._id = params._id;
            model.to_name = this.secureUrlLink.toname;
            model.cheque_signature =  this.secureUrlLink.name 
            
    

            let responseData = <any>{};
            this.busy = this.echexpaymentService.payChequeFromSecureLinkApi(model).subscribe(
            response => {
                //responseData = response;
                if (this.RedirectUrlLink) {
                    window.location.href = this.RedirectUrlLink;
                } else {
                    this.router.navigate(['/thank-you-url']);
                }
            },
            error => {
                responseData = error;
                this.chequeerror_res = responseData.error.message;
                // this.toastr.error(responseData.error.message, 'Failed!');
            }
           );
        } else{
			if (data.value.amount > 999999999) {
				this.showWarning = true;
				return;
			} 
		}
      
    }

    limitDecimalLength(inputElement: HTMLInputElement) {
		const regex = /^\d{0,9}(\.\d{0,2})?$/;
		const inputValue = inputElement.value;
		
		if (!regex.test(inputValue)) {
		  inputElement.value = inputValue.slice(0, -1);
		}
	}

	checkCharacterLimit(event: any) {
		const maxTextLength = 20; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
		const inputValue = event.target.value;
		
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
		  this.characterLimitReached = true; // Set the validation flag to true to show the warning message
		  setTimeout(() => {
			this.characterLimitReached = false; // Hide the warning message after 3 seconds
		  }, 3000);
		  event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	}

     //Length validation
	  NameCharacterLimit(event: any, fieldName: string, max_length:number) {
		const maxTextLength = max_length; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
			return;
		}
	
		const inputValue = event.target.value;
	
		if (inputValue.length >= maxTextLength) {
			if (allowedKeys.indexOf(inputChar) === -1) {
				this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
				setTimeout(() => {
				this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
				}, 3000);
				event.preventDefault(); // Prevent entering the exceeded character
			}
		}
	}
	isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/generate-checkout-url/checkout-url.component.ts